import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import Hero from '../components/Hero';
import Services from '../components/Services';
import BrandMessage from '../components/BrandMessage';
import CorporateCamps from '../components/CorporateCamps';
import HomeIndustries from '../components/HomeIndustries';
import PalletRackingForm from '../components/PalletRackingForm';

export default function Home() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -12 }}
      transition={{ duration: 0.35 }}
    >
      <Box>
        <Hero />
        <BrandMessage />
        <Services />
        <CorporateCamps />
        <HomeIndustries />
        <PalletRackingForm />
      </Box>
    </motion.div>
  );
}
